<template>
<div>
  <table class="table table-striped d-none d-md-table">
    <thead>
    <tr>
      <th scope="col">Adres budynku</th>
      <th scope="col">Robocze deklaracje A</th>
      <th scope="col">Złożone deklaracje A</th>
      <th scope="col">Robocze deklaracje B</th>
      <th scope="col">Złożone deklaracje B</th>
      <th scope="col">Akcje</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="building in buildings" :key="building.id">
      <td>
        {{ building.formatted_address }}
      </td>
      <td>{{ building.draft_a_declarations_count }}</td>
      <td>{{ building.submitted_a_declarations_count }}</td>
      <td>{{ building.draft_b_declarations_count }}</td>
      <td>{{ building.submitted_b_declarations_count }}</td>
      <td>
        <b-dropdown
          size="lg"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret right
        >
          <template #button-content>
            <b-icon-three-dots-vertical/>
            <span class="sr-only">User</span>
          </template>
          <b-dropdown-item
            href="#"
            @click="openEditBuildingModal(building)"
            v-if="(!anyDeclarationWasAdded(building)) || (building.editable)"
          >
            Edytuj budynek
          </b-dropdown-item>
          <b-dropdown-item
            href="#"
            @click="openDeleteModal(building)"
            v-if="!anyDeclarationWasAdded(building)"
          >
            Usuń budynek
          </b-dropdown-item>
          <b-dropdown-item
            @click="openDeclarationModal('A', building)"
          >
            Dodaj deklarację A
          </b-dropdown-item>
          <b-dropdown-item
            @click="openDeclarationModal('B', building)"
          >
            Dodaj deklarację B
          </b-dropdown-item>
        </b-dropdown>
      </td>
    </tr>
    </tbody>
  </table>

  <table class="table table-striped d-table d-md-none">
    <thead>
    <tr>
      <th scope="col">Budynek</th>
      <th scope="col">Akcje</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="building in buildings" :key="building.id">
      <td>
        {{ building.formatted_address }}<br />
        Robocze deklaracje A: {{ building.draft_a_declarations_count }}<br />
        Złożone deklaracje A: {{ building.submitted_a_declarations_count }}<br />
        Robocze deklaracje B: {{ building.draft_b_declarations_count }}<br />
        Złożone deklaracje B: {{ building.submitted_b_declarations_count }}
      </td>
      <td>
        <b-dropdown
          size="lg"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret right
        >
          <template #button-content>
            <b-icon-three-dots-vertical/>
            <span class="sr-only">User</span>
          </template>
          <b-dropdown-item
            href="#"
            @click="openEditBuildingModal(building)"
            v-if="(!anyDeclarationWasAdded(building)) || (building.editable)"
          >
            Edytuj budynek
          </b-dropdown-item>
          <b-dropdown-item
            href="#"
            @click="openDeleteModal(building)"
            v-if="!anyDeclarationWasAdded(building)"
          >
            Usuń budynek
          </b-dropdown-item>
          <b-dropdown-item
            @click="openDeclarationModal('A', building)"
          >
            Dodaj deklarację A
          </b-dropdown-item>
          <b-dropdown-item
            @click="openDeclarationModal('B', building)"
          >
            Dodaj deklarację B
          </b-dropdown-item>
        </b-dropdown>
      </td>
    </tr>
    </tbody>
  </table>
</div>
</template>

<script>
export default {
  name: "BuildingsTable",
  props: ['buildings'],
  methods: {
    openEditBuildingModal(data) {
      this.$store.commit("setBuildingToEdit", data);
      this.$store.commit("openBuildingsModal");
    },
    openDeclarationModal(type, data) {
      data.declarationType = type;
      this.$store.commit("setDeclarationBuilding", data);
      this.$store.commit("openDeclarationModal");
    },
    openDeleteModal(data) {
      if (this.anyDeclarationWasAdded(data)) {
        this.$store.commit("setDeleteBuildingData", {allowed: false});
        this.$bvModal.show('delete-building-modal');
        return;
      }
      let street = ((data.street) && (data.street.name) && (data.street.name.length)) ? data.street.name : (data.custom_street_name ? data.custom_street_name : '');
      let number = ((data.number) && (data.number.name) && (data.number.name.length)) ? data.number.name : (data.custom_number ? data.custom_number : '');
      let city = data.city.name;
      let postalCode = data.postal_code;
      const _data = {id: data.id, info: `${city} ${postalCode} ${street} ${number}`, allowed: true};
      this.$store.commit("setDeleteBuildingData", _data);
      this.$bvModal.show('delete-building-modal');
    },
    anyDeclarationWasAdded(buildingData) {
      return buildingData.draft_a_declarations_count > 0 ||
        buildingData.submitted_a_declarations_count > 0 ||
        buildingData.draft_b_declarations_count > 0 ||
        buildingData.submitted_b_declarations_count > 0;
    }
  },
}
</script>

<style scoped>

</style>
